export default "__VITE_ASSET__DLvGuhpF__"